import React from 'react';

import { FUNNEL_ORDER } from './FUNNEL_ORDER';
import FlavorSelect from './pantallas/FlavorSelect';
import ResultKcal from './pantallas/ResultKcal';

/**
 * Orden del funnel en modo kcal: reutiliza el perfil (P1..P6 + P8 salud; se
 * salta P7 alergias), añade la selección de sabores y termina en ResultKcal.
 */
export const KCAL_FUNNEL_ORDER: Record<number, React.FC> = {
  1: FUNNEL_ORDER[1], // P1 Welcome
  2: FUNNEL_ORDER[2], // P2 Datos básicos
  3: FUNNEL_ORDER[3], // P3 Raza
  4: FUNNEL_ORDER[4], // P4 Peso
  5: FUNNEL_ORDER[5], // P5 Actividad
  6: FUNNEL_ORDER[6], // P6 Comida actual
  7: FUNNEL_ORDER[8], // P8 Salud (P7 alergias fuera)
  8: FlavorSelect,
  9: ResultKcal,
};
